import { mutate as swrMutate } from 'swr'

import { CacheKey } from './cacheKey'

export const mutate = (key: CacheKey) => {
  swrMutate(key)
}
